/** Support inbox shown in the contact section and footer. */
export const SUPPORT_EMAIL = 'atenciónstockdigital@gmail.com'
